import { PrivacyText } from 'components/Policies'
import React from 'react'
import { ReactFC } from 'types'
import { TextPage } from './TextPage'


export const PrivacyPage: ReactFC = () => {
  return (
    <TextPage>
      <PrivacyText />
    </TextPage>
  )
}

export default PrivacyPage
